export default __webpack_public_path__ + "static/media/Photo.eefc4685.png";